/* eslint-disable no-empty-pattern */
import Store from "@/services/store";
import Router from "@/services/router";
import axios from "@/services/vue-axios";
import adaptersIn from "@/services/data-adapter/incoming/scheduler";
import { i18n } from "@/services/vue-i18n";

export default {
  init() {
    console.info("Scheduler module initialized.");
  },
  initModule({ dispatch }, module) {
    Store.registerModule(module.name, module.store);
    Router.addRoutes(module.routes);
    dispatch(module.name + "/init", null, { root: true });
  },

  // Events

  /**
   * Retrieves events from the backend.
   * @param {Object} param0
   * @param {Object} options Options to query the events gathering.
   * @param {Boolean} options.seeAll: See all the events. Otherwise, see the events for the current user.
   * @param {Boolean} options.seeCancelled: See the cancelled event the current user attended.
   * @param {Boolean} options.future: See only the events occuring in the future.
   */
  getEvents({ rootState, dispatch }, options = {}) {
    return new Promise((resolve, reject) => {
      const userId = options.userId ? options.userId : rootState.site.user.id;
      const endpoint = options.seeAll
        ? "/events"
        : "/users/" + userId + "/events";
      axios
        .get(endpoint, {
          params: {
            trashed: options.seeCancelled ? 1 : 0,
            start: options.start,
            end: options.end
          }
        })
        .then(response => {
          adaptersIn.events(response.data.events).then(res => resolve(res));
        })
        .catch(error => {
          handleError(error, i18n.t("app.actions.failed.fetch"));
          return reject();
        });

      var handleError = (error, message) => {
        if (process.APP_ENV !== "production") {
          console.log(error);
        }
        dispatch(
          "system/setStatus",
          {
            type: "error",
            message: message
          },
          { root: true }
        );
      };
    });
  },

  /**
   * Retrieves the participants of an event from the backend.
   * @param {Object} param0
   * @param {Array} eventId ID of the event the participants belong to.
   */
  getParticipants({ dispatch }, eventId) {
    return new Promise((resolve, reject) => {
      const endpoint = "/events/" + eventId + "/participations";
      axios
        .get(endpoint)
        .then(response => {
          adaptersIn
            .participants(response.data.participants)
            .then(res => resolve(res));
        })
        .catch(error => {
          handleError(error, i18n.t("app.actions.failed.fetch"));
          return reject();
        });

      var handleError = (error, message) => {
        if (process.APP_ENV !== "production") {
          console.log(error);
        }
        dispatch(
          "system/setStatus",
          {
            type: "error",
            message: message
          },
          { root: true }
        );
      };
    });
  }
};
